<template>
  <button
    class="bp-dropdown-item text-neutral-600"
    @click.prevent.stop="onClick"
  >
    <slot>
      <bp-icon size="18" :icon="icon" />
      <div>{{ text }}</div>
    </slot>

    <bp-dialog
      v-model="modal"
      v-bind="dialogProps"
      @action="dialogAction"
      @secondary-action="dialogAction(true)"
    />
  </button>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    action: {
      type: Function,
      default: null
    },
    event: {
      type: String,
      default: ""
    },
    confirmation: {
      type: Object,
      default: null
    },
    dialog: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      modal: false,
      dialogProps: this.confirmation || this.dialog || {}
    };
  },
  methods: {
    onClick() {
      this.$emit("toggle");

      if (this.action) {
        this.action();
        return;
      } else if (this.confirmation) {
        this.modal = true;
        return;
      }
      this.$emit("event", this.event);
    },

    dialogAction(secondary = false) {
      if (this.confirmation?.secondary) {
        secondary ? this.$emit("event", this.event) : {};
      } else {
        secondary ? {} : this.$emit("event", this.event);
      }
    }
  }
};
</script>
<style lang="scss">
.bp-dropdown-item {
  gap: 14px;
  width: 100%;
  border: none;
  display: flex;
  padding: 4px;
  padding-right: 12px;
  align-items: center;
  background-color: transparent;

  &:hover {
    background-color: rgba(215, 215, 215, 0.48);
  }

  &:active {
    background-color: rgba(215, 215, 215, 0.68);
  }
}
</style>
